import { createSlice } from '@reduxjs/toolkit';
import { Ai_traning_Data_update} from '../AI-Training/AItrainingApi';

const Ai_traning_Data_updateSlice = createSlice({
  name: 'Ai_traning_Data_update',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(Ai_traning_Data_update.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(Ai_traning_Data_update.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(Ai_traning_Data_update.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});
export default Ai_traning_Data_updateSlice.reducer;
